import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.js";
import { store } from "./store/index.js";
// The single stylesheet: Tailwind v4 plus the YKKBI tokens. The faces are
// self-hosted because the console runs inside the bank's network, where a CDN
// font request would either stall or leak which host is using the tool.
import "./index.css";

const container = document.getElementById("root");
if (!container) throw new Error("index.html is missing the #root container");

createRoot(container).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </StrictMode>,
);
